
import { NavLink} from 'react-router-dom';
import "../style/homeStyle.scss"
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import LocalHotelIcon from '@mui/icons-material/LocalHotel';
import MosqueIcon from '@mui/icons-material/Mosque';
import { AccessTimeFilledSharp } from '@mui/icons-material';
import TimelapseIcon from '@mui/icons-material/Timelapse';

export default function Home() {
   
  return (  
    <nav className="orbital-menu">  
    <ul className="orbital-menu__list">
      <li className="orbital-menu__item">
      <NavLink  to='athkarEsabah' className="orbital-menu__link orbital-menu__link_1">
          <span className="orbital-menu__link-icon">
            <LightModeIcon className='homeIcon'/>
          </span>
          <span className="orbital-menu__link-text">أذكار الصباح</span>
        </NavLink>
      </li>
      <li className="orbital-menu__item">
      <NavLink  to='athkarElmasaa' className="orbital-menu__link orbital-menu__link_2">
          <span className="orbital-menu__link-icon">
          <BedtimeIcon className='homeIcon'/>
          </span>
          <span className="orbital-menu__link-text">أذكار المساء</span>
        </NavLink>
      </li>
      <li className="orbital-menu__item">
      <NavLink  to='athkarElnom' className="orbital-menu__link orbital-menu__link_3">
          <span className="orbital-menu__link-icon">
          <LocalHotelIcon className='homeIcon'/>
          </span>
          <div className="stars"></div>
          <span className="orbital-menu__link-text">أذكار النوم</span>
        </NavLink>
      </li>
      <li className="orbital-menu__item">
      <NavLink  to='athkarEsalah' className="orbital-menu__link orbital-menu__link_4">
          <span className="orbital-menu__link-icon">
          <MosqueIcon className='homeIcon'/>
          </span>
          <span className="orbital-menu__link-text">أذكار الصلاة</span>
        </NavLink>
        
      </li>
       <li className="orbital-menu__item">
      <NavLink  to='werdAlthekr' className="orbital-menu__link orbital-menu__link_5">
          <span className="orbital-menu__link-icon">
          <AccessTimeFilledSharp className='homeIcon'/>
          </span>
          <span className="orbital-menu__link-text">ورد الذكر</span>
        </NavLink>
        
      </li>
       <li className="orbital-menu__item">
      <NavLink  to='AlathkarAlmudafa' className="orbital-menu__link orbital-menu__link_6">
          <span className="orbital-menu__link-icon">
          <TimelapseIcon className='homeIcon'/>
          </span>
          <span className="orbital-menu__link-text">الأذكار المضاعفة</span>
        </NavLink>
        
      </li>

    </ul>

  </nav>

    
  );
}